/** Read contents of @see file as a {string}. */
export function readFile(file: File): Promise<string> {
  return new Promise((resolve) => {
    const fileReader = new FileReader();
    fileReader.onload = async () => {
      resolve(fileReader.result as string);
    };
    fileReader.readAsText(file);
  });
}
